import { Queries } from "../graphql"
import { getToken, setToken, clearAllStorage } from "../utils/auth"
import apolloClient from "./apollo"
import { alertMessage } from '../utils/message'

export const refreshToken = () => {
    return new Promise(async (resolve, reject) => {
        const { errors, data } = await apolloClient.query({
            query: Queries.refreshToken,
            variables: {
                refreshToken: getToken().refreshToken,
                token: getToken().token
            },
        });
        console.log('result refreshToken : refreshToken.js : line 14', { errors, data })
        try {
            if (!errors) {
                setToken(data.refreshToken)
                const { accessToken } = data.refreshToken
                resolve({ newToken: accessToken })
            }else if (errors && errors[0].extensions.code === 'TOKEN_INVALID') {
               // message.error('มีบางอย่างผิดพลาดกรุณาลองใหม่อีกครั้ง.')
               console.log('apollo.js| line:95| errors[0].extensions.code = ' + errors[0].extensions.code)
               alertMessage("error", "พบข้อผิดพลาด กรุณาติดต่อผู้ดูแลระบบ")
               clearAllStorage()
               window.location.href = '/login'
            } else {
                reject(errors)
            }
        } catch (error) {
            reject(errors)
        }
    })
}
